import { PopupBuilder } from '@mobile/views/Relation/Shared/Popup/builder/PopupBuilder'

import NumberOfLegByesPopupDetails from './NumberOfLegByesPopupDetails.vue'

export const NumberOfLegByesPopup = new PopupBuilder('Number of Leg Byes')
  .appendBody(NumberOfLegByesPopupDetails)
  .build()
